import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Image from '../elements/Image';
import Modal from '../elements/Modal';

const propTypes = {
  ...SectionProps.types
};

const defaultProps = {
  ...SectionProps.defaults
};

class HeroFullSuperSearch extends React.Component {
  state = {
    videoModalActive: false
  };
  openModal = (e) => {
    e.preventDefault();
    this.setState({ videoModalActive: true });
  };

  closeModal = (e) => {
    e.preventDefault();
    this.setState({ videoModalActive: false });
  };

  render() {
    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'hero section center-content',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'hero-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    return (
      <section {...props} className={outerClasses}>
        <div className="container-sm">
          <div className={innerClasses}>
            <div className="hero-content">
              <div className="container-xs">
                <h1 className="mt-0 reveal-from-top">
                  Search and replace Miro board content with powerful filters.
                </h1>
              </div>
            </div>
            <div
              className="hero-figure illustration-element-02 reveal-from-bottom"
              data-reveal-delay="200"
            >
              <a
                data-video="https://customer-9qzbdpfg1n4t9u3r.cloudflarestream.com/9aa0160b4db654ea85e331b41cb1cd3d/downloads/default.mp4"
                href="#0"
                aria-controls="video-modal"
                onClick={this.openModal}
              >
                <Image
                  src={require('./../../assets/images/super-search.png')}
                  alt="Video"
                  width={896}
                  height={504}
                />
              </a>
            </div>
            <Modal
              id="video-modal"
              show={this.state.videoModalActive}
              handleClose={this.closeModal}
              video="https://customer-9qzbdpfg1n4t9u3r.cloudflarestream.com/9aa0160b4db654ea85e331b41cb1cd3d/downloads/default.mp4"
              videoTag="video"
            />
          </div>
        </div>
      </section>
    );
  }
}

HeroFullSuperSearch.propTypes = propTypes;
HeroFullSuperSearch.defaultProps = defaultProps;

export default HeroFullSuperSearch;
